module.exports = __webpack_public_path__ + "img/avatar.2b257228.svg";